import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// ====================================================================================
// Copyright © 2025 Joaquim Sá Carneiro. Todos os direitos reservados.
// Configuração de Segurança Máxima com App Check
// ====================================================================================

const firebaseConfig = {
  apiKey: "AIzaSyBljPC_YbNNOu1dA_5d1_JoHzowcn5IWuI",
  authDomain: "vintage-praia-react.firebaseapp.com",
  projectId: "vintage-praia-react",
  storageBucket: "vintage-praia-react.firebasestorage.app", 
  messagingSenderId: "642481847141",
  appId: "1:642481847141:web:c9941eca3b7e7b98cabf8c"
};

// Variáveis de instância
let app;
let auth;
let db;
let storage;
let functions;
let appId = "vintage-praia-react";
let appCheck;

try {
    // Inicializar App Principal
    app = initializeApp(firebaseConfig);
    
    // Inicializar App Check (Obrigatório para evitar Erro 403)
    // A Site Key PRECISA de aspas: 
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider("6LcmvrAsAAAAAN-NJcWYN-Y4KO3guaQk5fulBxh-"),
      isTokenAutoRefreshEnabled: true
    });

    // Inicializar Serviços
    auth = getAuth(app);
    db = getFirestore(app);
    storage = getStorage(app);
    functions = getFunctions(app);

    console.log("✅ Firebase e App Check inicializados com sucesso.");
} catch (error) {
    console.error("❌ Erro na inicialização do Firebase:", error);
}

// Exportar instâncias para o resto do código (BookingWidget.js, etc)
// Adicionada a exportação de firebaseConfig para resolver o erro de compilação
export { app, auth, db, storage, functions, appId, appCheck, firebaseConfig };